import React, { useState, useEffect, useCallback } from "react";
import useStyles from "./style";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Slide,
  DialogActions,
  Typography,
  Button,
  IconButton,
  Divider,
  MenuItem,
  TextField,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";

// Redux
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";

// Services
import VehicleApi from "Services/Vehicle";
import DriverApi from "Services/Driver";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const AssignDriverModal = (props) => {
  const { openDialog, handleClose, vehicleRow } = props;
  const classes = useStyles();
  const dispatch = useDispatch();

  const [drivers, setDrivers] = useState([]);
  const [selectedDriver, setSelectedDriver] = useState("");

  const fetchDrivers = useCallback(() => {
    DriverApi.getDriverList({ page: 1, limit: "unlimited", search: "" }).then(
      (res) => {
        if (res?.status===200) {
          setDrivers(res?.data?.data?.data || []);
        }
      },
      () => {}
    );
  }, []);

  useEffect(() => {
    if (openDialog) {
      fetchDrivers();
      // vehicleRow.raw.assignedDriver can be an object or string
      const currentAssigned = vehicleRow?.raw?.assignedDriver;
      if (currentAssigned) {
        setSelectedDriver(currentAssigned._id || currentAssigned);
      } else {
        setSelectedDriver("");
      }
    }
  }, [openDialog, vehicleRow, fetchDrivers]);

  const handleAssignSubmit = () => {
    dispatch(showLoader("Assigning driver please wait..."));

    const data = {
      vehicleId: vehicleRow.raw._id,
      driverId: selectedDriver,
    };

    VehicleApi.assignDriver(data)
      .then((res) => {
        dispatch(hideLoader());
        if (res?.status===200) {
          dispatch(
            showSnackbar({
              message: res.data.message || "Driver assigned successfully",
              autoHideDuration: 3000,
              anchorOrigin: { vertical: "top", horizontal: "right" },
              variant: "success",
            })
          );
          handleClose();
        }
      })
      .catch((err) => {
        dispatch(hideLoader());
        const message = err?.response?.data?.message || "Error assigning driver";
        dispatch(
          showSnackbar({
            message,
            autoHideDuration: 3000,
            anchorOrigin: { vertical: "top", horizontal: "right" },
            variant: "error",
          })
        );
      });
  };

  return (
    <Dialog
      open={openDialog}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      aria-describedby="assign-driver-dialog"
      className={classes.root}
    >
      <DialogTitle>
        <section className={classes.dialogTitleContainer}>
          <Typography variant="body1" className={classes.title}>
            Assign Driver
          </Typography>
          <IconButton aria-label="close" onClick={handleClose}>
            <CloseIcon className={classes.closeIcon} />
          </IconButton>
        </section>
      </DialogTitle>
      
      <DialogContent>
        {vehicleRow && (
          <div className={classes.vehicleInfoContainer}>
            {vehicleRow.vehicle_image ? (
              <img
                src={vehicleRow.vehicle_image}
                alt="Vehicle"
                className={classes.vehicleImage}
              />
            ) : (
              <div className={classes.noImageWrapper}>
                <DirectionsCarIcon style={{ fontSize: 56, color: "#aaa" }} />
              </div>
            )}
            <Typography className={classes.vehicleNo}>
              {vehicleRow.vehicle_no}
            </Typography>
          </div>
        )}

        <div className={classes.textFieldWrapper}>
          <TextField
            id="driver-select"
            label="Select Driver"
            value={selectedDriver}
            onChange={(e) => setSelectedDriver(e.target.value)}
            select
            fullWidth
            variant="outlined"
            size="small"
          >
            <MenuItem value="">-- No Driver --</MenuItem>
            {drivers.map((d) => (
              <MenuItem key={d._id} value={d._id}>
                {d.firstName} {d.lastName} ({d.countryCode} {d.mobileNumber})
              </MenuItem>
            ))}
          </TextField>
        </div>

        <div className={classes.sbtBtnWrapper}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleAssignSubmit}
            startIcon={<PersonAddAlt1Icon />}
            fullWidth
          >
            {selectedDriver ? "Assign Driver" : "Update & Remove Driver"}
          </Button>
        </div>
      </DialogContent>

      <Divider />
      <DialogActions>
        <section className={classes.dialogActions}>
          <Button onClick={handleClose}>Close</Button>
        </section>
      </DialogActions>
    </Dialog>
  );
};

export default AssignDriverModal;
